import { Component, ViewEncapsulation, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

import { FormatNodeEventArgs, TreeView, TreeNode } from '@grapecity/wijmo.nav';

import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { CheckboxLabelComponent } from '../../../commons/kymw02/checkbox-label/checkbox-label.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { NotNullTextInputComponent } from '../../../commons/kymw02/not-null-text-input/not-null-text-input.component';

import { KYMW5300Model } from './kymw5300.model';
import { KYMW5300commonModel } from './vo/kymw5300-common.model';

import { GetCategoryInfoService } from './api-services/get-category-info.service';
import { UpdateCategoryShowSeqInfoService } from './api-services/update-category-show-seq-info.service';
import { UpdateCategoryInfoService } from './api-services/update-category-info.service';
import { RegistCategoryInfoService } from './api-services/regist-category-info.service';
import { DeleteCategoryInfoService } from './api-services/delete-category-info.service';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { Subject } from 'rxjs';

/**
 * ECカテゴリマスタ画面を管理するクラス
 *
 * @export KYMW5300Component
 * @class KYMW5300Component
 */
@Component({
  selector: 'app-kymw5300',
  templateUrl: 'kymw5300.component.html',
  styleUrls: ['kymw5300.component.scss'],
  providers: [
    GetCategoryInfoService,
    UpdateCategoryShowSeqInfoService,
    UpdateCategoryInfoService,
    RegistCategoryInfoService,
    DeleteCategoryInfoService,
  ],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5300Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('tre_Category', { static: true }) tre_Category: TreeView;
  @ViewChild('tre_Category', { static: true }) tre_Category_node: TreeNode;

  @ViewChild('rdb_PlanCategory', { static: true }) rdb_PlanCategory: RadioLabelComponent;
  @ViewChild('rdb_StockCategory', { static: true }) rdb_StockCategory: RadioLabelComponent;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;
  @ViewChild('btn_Makeroot', { static: true }) btn_Makeroot: ElementRef;
  @ViewChild('btn_Addchild', { static: true }) btn_Addchild: ElementRef;
  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;
  @ViewChild('btn_Upper', { static: true }) btn_Upper: ElementRef;
  @ViewChild('btn_Lower', { static: true }) btn_Lower: ElementRef;
  @ViewChild('txti_ToShowSeq', { static: true }) txti_ToShowSeq: ElementRef;
  @ViewChild('btn_Move', { static: true }) btn_Move: ElementRef;
  @ViewChild('btn_Cancel', { static: true }) btn_Cancel: ElementRef;
  @ViewChild('btn_Update', { static: true }) btn_Update: ElementRef;
  @ViewChild('txti_CategoryName', { static: true }) txti_CategoryName: NotNullTextInputComponent;
  @ViewChild('ckb_ShowDiv', { static: true }) ckb_ShowDiv: CheckboxLabelComponent;
  @ViewChild('ckb_SellAreaDivB', { static: true }) ckb_SellAreaDivB: CheckboxLabelComponent;
  @ViewChild('ckb_SellAreaDivN', { static: true }) ckb_SellAreaDivN: CheckboxLabelComponent;
  @ViewChild('ckb_SellAreaDivM', { static: true }) ckb_SellAreaDivM: CheckboxLabelComponent;
  @ViewChild('ckb_SellAreaDivW', { static: true }) ckb_SellAreaDivW: CheckboxLabelComponent;
  @ViewChild('ckb_SellAreaDivS', { static: true }) ckb_SellAreaDivS: CheckboxLabelComponent;
  @ViewChild('ckb_SellAreaDivSP', { static: true }) ckb_SellAreaDivSP: CheckboxLabelComponent;
  @ViewChild('ckb_SellAreaDivEC', { static: true }) ckb_SellAreaDivEC: CheckboxLabelComponent;
  @ViewChild('ckb_CategoryDiv', { static: true }) ckb_CategoryDiv: CheckboxLabelComponent;

  @ViewChild('cmb_BorderLineDiv', { static: true }) cmb_BorderLineDiv: CodeComboBoxComponent;


  // 親画面からの連携値
  param: any;

  // モデルをインスタンス化
  kymw5300Model: KYMW5300Model = new KYMW5300Model();

  // ツリーテスト 画面表示用
  selectedItem: string;

  /**
   * ユーザ権限
   *  ０：使用不可、１：閲覧のみ、２：フルコントロール可能（帳票出力、更新）
   *  isFullControl：フルコントロール権限
   */
  public enableMode = String('');
  public isFullControl;

  private eventFlg = String('');                                        // 0:初期化
  // 1:ルート新規追加
  // 2:子追加
  // 3:削除
  // 4,5:矢印
  // 6:更新

  /**
   * ボーダーライン表示区分 ボーダーラインなし
   */
  private readonly NO_BORDER_LINE: string = String('0');

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  ngOnInit(): void {
    this.componentName = 'KYMW5300';
    // モデルに自身を入れる
    this.kymw5300Model.kYMW5300Component = this;

    // 権限取得
    // ０：使用不可、１：閲覧のみ、２：フルコントロール可能（帳票出力、更新）
    this.enableMode = this.getFuncPermission('KYMW5300');
    this.isFullControl = this.enableMode === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;

    // 初期表示
    this.kymw5300Model.stockLimitFlg = '0';                                     // 在庫限定フラグ
    this.kymw5300Model.orderCode = '';                                          // 受注コード
    this.kymw5300Model.catalogId = '';                                          // 配達企画回
    this.kymw5300Model.toShowSeq = '';                                          // 移動先表示順
    this.kymw5300Model.categoryCode = '';                                       // カテゴリコード
    this.kymw5300Model.categoryName = '';                                       // カテゴリ名称
    this.kymw5300Model.categoryParentName = '';                                 // 親カテゴリ名称
    this.kymw5300Model.borderLineDiv = '';                                      // ボーダーライン区分
    this.kymw5300Model.showDiv = false;                                         // 一時非表示区分
    this.kymw5300Model.sellAreaDivB = false;                                    // 売場毎表示区分(ブロードバンド)
    this.kymw5300Model.sellAreaDivN = false;                                    // 売場毎表示区分(ナローバンド)
    this.kymw5300Model.sellAreaDivM = false;                                    // 売場毎表示区分(携帯)
    this.kymw5300Model.sellAreaDivW = false;                                    // 売場毎表示区分(Webカタログ)
    this.kymw5300Model.sellAreaDivS = false;                                    // 売場毎表示区分(スマートフォン)
    this.kymw5300Model.sellAreaDivSP = false;                                   // 売場毎表示区分(スポット)
    this.kymw5300Model.sellAreaDivEC = false;                                   // 売場毎表示区分(ECサイト)
    this.kymw5300Model.categoryDiv = false;                                     // カテゴリ区分

    setTimeout(() => {
      this.plessEnabledSetting();

      // テキスト背景色を強制的に『非活性』にするための処理
      this.txti_CategoryName.textChanged();
    });

    // 各種フラグ
    this.eventFlg = '0';                                                        // イベントフラグ(0:初期化)

    this.eventListenerSetting();
  }

  eventListenerSetting() {
    /**
     * 編集済みチェック用に、イベントを割り当て
     */
    const changeObj = [
      // 文字,チェックボックス
      'txti_CategoryName', 'cmb_BorderLineDiv', 'ckb_ShowDiv',
      'txti_ToShowSeq',
      'ckb_SellAreaDivB', 'ckb_SellAreaDivN', 'ckb_SellAreaDivM', 'ckb_SellAreaDivW',
      'ckb_SellAreaDivS', 'ckb_SellAreaDivSP', 'ckb_SellAreaDivEC','ckb_CategoryDiv'
    ];

    for (let i = Number(0); i < changeObj.length; i++) {
      document.getElementById(changeObj[i]).addEventListener('change', () => this.eventEditHandler());
    }
  }

  /**
   * 表示ボタンを押下した時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventDisplay_CLICKHandler(): void {
    // チェックしたカタログIDをモデルへ
    this.kymw5300Model.catalogId = this.txti_OrderCode.selectedCatalogID;
    const kymw5300commonVO: KYMW5300commonModel = new KYMW5300commonModel();

    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5300Model.orderCode)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['受注コード']);
      return;
    }

    // 在庫限定フラグ必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5300Model.stockLimitFlg)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['在庫限定フラグ']);
      return;
    }

    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5300Model.catalogId)) {
      this.dialogServiceSub.openAlertGetMessage('E0122', ['受注コード']);
      return;
    }

    // カテゴリ詳細情報クリア処理
    this.clearDetail();
    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';

    // 表示イベント用VO初期化処理
    kymw5300commonVO.orderCode = this.kymw5300Model.orderCode;                  // 受注コード
    kymw5300commonVO.stockLimitFlg = this.kymw5300Model.stockLimitFlg;          // 在庫限定フラグ

    // イベントの発行
    this.getCategoryInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
  }

  /**
   * 更新を押下した時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventUpdate_CLICKHandler(): void {
    // カテゴリ名称の入力チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5300Model.categoryName)) {           // 未入力の場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0110', ['カテゴリ名称']);
      return;
    }

    // ボーダーライン表示の入力チェック
    if (!this.kymw5300Model.borderLineDiv) {                                  // 未選択の場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0110', ['ボーダーライン表示']);
      return;
    }

    // ルート作成、子追加以外のときカテゴリーチェック
    if ((this.eventFlg !== '1')                                                 // 「1:ルート追加」以外、かつ、
      && (this.eventFlg !== '2')) {                                             // 「2:子追加」以外の場合
      // カテゴリコードの入力チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw5300Model.categoryCode)) {         // 未入力の場合
        this.categoryDivEnabledSetting();
        this.dialogServiceSub.openAlertGetMessage('E0110', ['カテゴリコード']);
        return;
      }
    }

    // 受注コード比較
    if (!this.checkOrderCode()) {                                               // 異なる場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0121', ['入力した受注コード', '表示カテゴリの受注コード']);
      return;
    }

    // 更新確認メッセージを表示
    // 入力した情報で{0}を更新しますか？
    this.dialogServiceSub.openAlertGetMessage('Q0105', ['カテゴリ情報'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.dispatcherUpdateEvent();
        }
      });
  }

  /**
   * 更新イベント発行
   *
   * @memberof KYMW5300Component
   */
  public dispatcherUpdateEvent(): void {
    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';

    let rootXML: any = null;
    let strwk: string = null;
    let list: any = null;

    let sellAreaDivWK = String('');

    // 更新イベント用VOの初期化処理
    const kymw5300commonVO: KYMW5300commonModel = new KYMW5300commonModel();

    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;	                  // 選択カテゴリ
    let parentItem: any;
    if (selectedItem && this.tre_Category.getNode(selectedItem).parentNode) {
      parentItem = this.tre_Category.getNode(selectedItem).parentNode.dataItem; // 親カテゴリ
    }
    // イベントフラグのチェック
    if (this.eventFlg === '1') {                                                // 「1:ルート追加」の場合
      // 更新イベント用VOの初期化処理
      rootXML = this.tre_Category.itemsSource;
      strwk = '000000001';
      kymw5300commonVO.categoryCode = strwk;                                    // カテゴリコード
      kymw5300commonVO.showSeq = this.kymw5300Model.categoryInfoList.length;    // parentItem.Category.length + 1;	// 表示順
      kymw5300commonVO.categoryParent = '';                                     // 親カテゴリコード
      kymw5300commonVO.categoryLevel = 1;                                       // カテゴリ階層
    } else if (this.eventFlg === '2') {                                         // 「2:子追加」の場合
      // 更新イベント用VOの初期化処理
      strwk = '000000001';
      list = selectedItem.Category;
      kymw5300commonVO.categoryCode = strwk;                                    // カテゴリコード
      kymw5300commonVO.showSeq = (selectedItem.Category) ? selectedItem.Category.length + 1 : 1;  // 表示順
      kymw5300commonVO.categoryParent = selectedItem.CategoryCode;              // 親カテゴリコード

      const level = Number(selectedItem.CategoryLevel);
      kymw5300commonVO.categoryLevel = level + 1;                               // カテゴリ階層
    } else {                                                                    // 上記以外の場合
      // 更新イベント用VOの初期化処理
      kymw5300commonVO.categoryCode = selectedItem.CategoryCode;                // カテゴリコード
      kymw5300commonVO.showSeq = selectedItem.ShowSeq;                          // 表示順
      kymw5300commonVO.categoryParent = selectedItem.ParentCategoryCode;        // 親カテゴリコード
      kymw5300commonVO.categoryLevel = selectedItem.CategoryLevel;              // カテゴリ階層
      kymw5300commonVO.updateDate = selectedItem.UpdateDate;                    // 更新日時
    }

    // 更新イベント用VOの初期化処理
    kymw5300commonVO.orderCode = this.kymw5300Model.orderCode;                  // 受注コード
    kymw5300commonVO.categoryName = this.kymw5300Model.categoryName;            // カテゴリ名称
    kymw5300commonVO.borderLineDiv = this.kymw5300Model.borderLineDiv;

    kymw5300commonVO.showDiv = this.kymw5300Model.showDiv ? '1' : '0';

    sellAreaDivWK = this.kymw5300Model.sellAreaDivB ? '1' + sellAreaDivWK : '0' + sellAreaDivWK;
    sellAreaDivWK = this.kymw5300Model.sellAreaDivN ? '1' + sellAreaDivWK : '0' + sellAreaDivWK;
    sellAreaDivWK = this.kymw5300Model.sellAreaDivM ? '1' + sellAreaDivWK : '0' + sellAreaDivWK;
    sellAreaDivWK = this.kymw5300Model.sellAreaDivW ? '1' + sellAreaDivWK : '0' + sellAreaDivWK;
    sellAreaDivWK = this.kymw5300Model.sellAreaDivS ? '1' + sellAreaDivWK : '0' + sellAreaDivWK;
    sellAreaDivWK = this.kymw5300Model.sellAreaDivSP ? '1' + sellAreaDivWK : '0' + sellAreaDivWK;
    sellAreaDivWK = this.kymw5300Model.sellAreaDivEC ? '1' + sellAreaDivWK : '0' + sellAreaDivWK;
    kymw5300commonVO.SellAreaDiv = '0' + sellAreaDivWK; // 売場毎表示区分(予備)(0:表示しない)
    kymw5300commonVO.categoryDiv = this.kymw5300Model.categoryDiv ? '0' : '1'; // カテゴリ区分

    if (this.eventFlg === '1' || this.eventFlg === '2') {
      // ルート新規作成か子追加の場合：登録
      kymw5300commonVO.stockLimitFlg = this.kymw5300Model.stockLimitFlg; // 在庫限定フラグ
      this.registCategoryInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
    } else {
      this.updateCategoryInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
    }
  }

  /**
   * 更新完了後処理
   *
   * @memberof KYMW5300Component
   */
  public updateSuccess(): void {
    // イベントクリア
    this.eventClear();

    // カテゴリ詳細情報クリア処理
    this.clearDetail();
    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';

    const kymw5300commonVO: KYMW5300commonModel = new KYMW5300commonModel();

    // 表示イベント用VO初期化処理
    kymw5300commonVO.orderCode = this.kymw5300Model.orderCode;                  // 受注コード
    kymw5300commonVO.stockLimitFlg = this.kymw5300Model.stockLimitFlg;          // 在庫限定フラグ

    // イベントの発行
    this.getCategoryInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
  }

  /**
   * 削除ボタンを押下した時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventDelete_CLICKHandler(): void {
    // 受注コード比較
    if (!this.checkOrderCode()) {                                               // 異なる場合
      this.dialogServiceSub.openAlertGetMessage('E0121', ['入力した受注コード', '表示カテゴリの受注コード']);
      return;
    }

    // 未選択チェック
    if (PlessViewUtilsSub.isEmpty(this.tre_Category.selectedItem)) {            // 未選択の場合
      this.dialogServiceSub.openAlertGetMessage('E0164', ['選択されていない', '設定']);
      return;
    }

    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;

    // 子カテゴリ数のチェック
    if (selectedItem.Category) {
      if (selectedItem.Category.length !== 0) {                                 // 子カテゴリが存在する場合
        this.dialogServiceSub.openAlertGetMessage('E0157', ['子カテゴリ', '削除']);
        return;
      }
    }

    // 確認メッセージを表示
    // {0}を削除します。よろしいですか？
    this.dialogServiceSub.openAlertGetMessage('Q0106', ['選択したカテゴリ情報'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.dispatcherDeleteEvent();
        }
      });
  }

  /**
   * 削除イベント発行
   *
   * @memberof KYMW5300Component
   */
  public dispatcherDeleteEvent(): void {
    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';
    // データ削除条件の設定
    const kymw5300commonVO: KYMW5300commonModel = new KYMW5300commonModel();

    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;

    // 削除イベント用VO初期化処理
    kymw5300commonVO.orderCode = this.kymw5300Model.orderCode;                  // 受注コード
    kymw5300commonVO.categoryCode = selectedItem.CategoryCode;                  // カテゴリコード
    kymw5300commonVO.categoryParent = selectedItem.ParentCategoryCode;          // 親カテゴリコード
    kymw5300commonVO.categoryLevel = selectedItem.CategoryLevel;                // カテゴリ階層
    kymw5300commonVO.showSeq = selectedItem.ShowSeq;                            // 表示順
    kymw5300commonVO.updateDate = selectedItem.UpdateDate;                      // 更新日時
    kymw5300commonVO.stockLimitFlg = this.kymw5300Model.stockLimitFlg;          // 在庫限定フラグ

    // イベントの発行
    this.deleteCategoryInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
  }

  /**
   * カテゴリ一覧で選択された時に呼び出されるメソッド
   *
   * @param {Event} event
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventSelect_CLICKHandler(event: Event): void {
    // カテゴリ一覧の活性状態のチェック
    if (!this.tre_Category) {                                                   // 非活性の場合
      // カテゴリ追加時（選択不可）は処理しない
      return;
    }

    // 未選択チェック
    // カテゴリ一覧の選択インデックスのチェック
    if (PlessViewUtilsSub.isEmpty(this.tre_Category.selectedItem)) {            // 未選択の場合
      this.dialogServiceSub.openAlertGetMessage('E0164', ['選択されていない', '設定']);
      return;
    }

    // イベントクリア処理
    this.eventClear();

    // カテゴリ選択時のカテゴリ詳細情報初期化処理
    this.initDetailForSelect();

    // カテゴリ選択時の活性制御
    this.enableControlForSelect();
    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';
  }

  /**
   * カテゴリ一覧でキーボードで選択された時に呼び出されるメソッド
   *
   * @param {*} event
   * @memberof KYMW5300Component
   */
  public eventKeybordSelect_KEYDOWNHandler(event: any): void {
    // キーコードのチェック
    if (event.keyCode === event.ENTER) {                                        // Enterキーの場合
      // エンターキーの場合はそのカテゴリが選択されたものとして処理する
      this.eventSelect_CLICKHandler(event);
    }
  }

  /**
   * ルート新規作成を押下した時に呼び出されるメソッド
   *
   * @memberof KYMW5300Component
   */
  public eventMakeroot_CLICKHandler(): void {
    // 「1:ルート新規作成」
    this.eventFlg = '1';
    this.kymw5300Model.toShowSeq = '';
    this.kymw5300Model.isEdited = false;

    this.kymw5300Model.categoryCode = '';
    this.kymw5300Model.categoryName = '';
    this.kymw5300Model.borderLineDiv = this.NO_BORDER_LINE;
    this.kymw5300Model.showDiv = false;
    this.kymw5300Model.sellAreaDivB = true;
    this.kymw5300Model.sellAreaDivN = true;
    this.kymw5300Model.sellAreaDivM = true;
    this.kymw5300Model.sellAreaDivW = true;
    this.kymw5300Model.sellAreaDivS = true;
    this.kymw5300Model.sellAreaDivSP = true;
    this.kymw5300Model.sellAreaDivEC = true;
    this.kymw5300Model.categoryDiv = false;

    this.enableControlForAddCategory();

    this.txti_CategoryName.input.nativeElement.focus();
  }

  /**
   * 子追加を押下した時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventAddchild_CLICKHandler(): void {
    // 未選択チェック
    if (PlessViewUtilsSub.isEmpty(this.tre_Category.selectedItem)) {            // 未選択の場合
      this.dialogServiceSub.openAlertGetMessage('E0164', ['カテゴリが選択されていない', '設定']);
      return;
    }

    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;

    // カテゴリ階層のチェック
    if (selectedItem.CategoryLevel === '3') {                                   // 第3階層の場合
      this.dialogServiceSub.openAlertGetMessage('E0164', ['第3階層', '追加']);
      // 階層は第3階層までのため、子カテゴリの追加は不可
      return;
    }

    // 在庫限定フラグのチェック
    if (this.kymw5300Model.stockLimitFlg === '1') {
      this.dialogServiceSub.openAlertGetMessage('E0164', ['在庫限定カテゴリ', '追加']);
      // 在庫限定カテゴリは子カテゴリの追加は不可
      return;
    }

    // 「2:子追加」
    this.eventFlg = '2';
    this.kymw5300Model.isEdited = false;
    this.kymw5300Model.toShowSeq = '';

    // 「:」より前の文字列(表示順)をカット
    const iPos: number = selectedItem.CategoryName.indexOf(':');
    this.kymw5300Model.categoryParentName = selectedItem.CategoryName.slice(iPos + 1);
    this.kymw5300Model.categoryName = '';
    this.kymw5300Model.borderLineDiv = this.NO_BORDER_LINE;
    this.kymw5300Model.showDiv = false;
    this.kymw5300Model.sellAreaDivB = true;
    this.kymw5300Model.sellAreaDivN = true;
    this.kymw5300Model.sellAreaDivM = true;
    this.kymw5300Model.sellAreaDivW = true;
    this.kymw5300Model.sellAreaDivS = true;
    this.kymw5300Model.sellAreaDivSP = true;
    this.kymw5300Model.sellAreaDivEC = true;
    this.kymw5300Model.categoryDiv = false;
    
    this.enableControlForAddCategory();

    this.txti_CategoryName.input.nativeElement.focus();
  }

  /**
   * 上矢印を押下した時に呼び出されるメソッド
   *
   * @param {Event} event
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventUpper_CLICKHandler(event: Event): void {
    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';

    // 未選択チェック
    if (PlessViewUtilsSub.isEmpty(this.tre_Category.selectedItem)) {            // 未選択の場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0164', ['カテゴリが選択されていない', '設定']);
      return;
    }

    // 受注コード比較
    if (!this.checkOrderCode()) {                                               // 異なる場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0121', ['入力した受注コード', '表示カテゴリの受注コード']);
      return;
    }

    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;

    // データ更新条件の設定
    const kymw5300commonVO: KYMW5300commonModel = new KYMW5300commonModel();

    // 更新イベント用VO初期化処理
    kymw5300commonVO.moveDiv = '0';
    kymw5300commonVO.orderCode = this.kymw5300Model.orderCode;
    kymw5300commonVO.categoryCode = selectedItem.CategoryCode;
    kymw5300commonVO.categoryLevel = selectedItem.CategoryLevel;
    kymw5300commonVO.showSeq = selectedItem.ShowSeq;
    kymw5300commonVO.categoryCode = selectedItem.CategoryCode;
    kymw5300commonVO.categoryParent = selectedItem.ParentCategoryCode;
    kymw5300commonVO.updateDate = selectedItem.UpdateDate;
    kymw5300commonVO.stockLimitFlg = this.kymw5300Model.stockLimitFlg;
    kymw5300commonVO.moveSeq = 1;

    // サーバー通信
    this.updateCategoryShowSeqInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
  }

  /**
   * ↓矢印を押下した時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventLower_CLICKHandler(): void {
    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';

    // 未選択チェック
    if (PlessViewUtilsSub.isEmpty(this.tre_Category.selectedItem)) {            // 未選択の場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0164', ['カテゴリが選択されていない', '設定']);
      return;
    }

    // 受注コード比較
    if (!this.checkOrderCode()) {                                               // 異なる場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0121', ['入力した受注コード', '表示カテゴリの受注コード']);
      return;
    }

    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;

    // データ更新条件の設定
    const kymw5300commonVO: KYMW5300commonModel = new KYMW5300commonModel();

    // 更新イベント用VO初期化処理
    kymw5300commonVO.moveDiv = '1';
    kymw5300commonVO.orderCode = this.kymw5300Model.orderCode;
    kymw5300commonVO.categoryCode = selectedItem.CategoryCode;
    kymw5300commonVO.categoryLevel = selectedItem.CategoryLevel;
    kymw5300commonVO.showSeq = selectedItem.ShowSeq;
    kymw5300commonVO.categoryCode = selectedItem.CategoryCode;
    kymw5300commonVO.categoryParent = selectedItem.ParentCategoryCode;
    kymw5300commonVO.updateDate = selectedItem.UpdateDate;
    kymw5300commonVO.stockLimitFlg = this.kymw5300Model.stockLimitFlg;
    kymw5300commonVO.moveSeq = 1;

    // サーバー通信
    this.updateCategoryShowSeqInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
  }

  /**
   * 移動ボタンを押下した時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventMove_CLICKHandler(): void {
    // 未選択チェック
    if (PlessViewUtilsSub.isEmpty(this.tre_Category.selectedItem)) {            // 未選択の場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0164', ['カテゴリが選択されていない', '設定']);
      return;
    }

    // 受注コード比較
    if (!this.checkOrderCode()) {                                               // 異なる場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0121', ['入力した受注コード', '表示カテゴリの受注コード']);
      return;
    }

    // 移動先表示順の必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5300Model.toShowSeq)) {
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0110', ['移動先表示順']);
      return;
    }

    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;
    // 表示順取得
    const showSeq = Number(selectedItem.ShowSeq);
    // 移動先表示順取得
    const toShowSeq = Number(this.kymw5300Model.toShowSeq);

    // 親カテゴリを取得
    let parentItem: any = null;
    let parentLen = Number(0);

    if (this.tre_Category.getNode(selectedItem).parentNode) {
      parentItem = this.tre_Category.getNode(selectedItem).parentNode.dataItem; // 親カテゴリ
      // 親カテゴリの子カテゴリ数を取得
      parentLen = parentItem.Category.length;
    } else {
      // 第一階層の場合はリストの総数から取得
      parentLen = this.kymw5300Model.categoryInfoList.length;
    }

    // 移動先表示順入力値チェック
    if (toShowSeq < 1 || toShowSeq > parentLen) {
      // 移動先表示順が1より小さい,または同一階層のカテゴリ数を越える場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0164', ['指定された表示順が範囲外', '更新']);
      return;
    }

    if (toShowSeq === showSeq) {
      // 移動先表示順現在の表示順と同一の場合
      this.categoryDivEnabledSetting();
      this.dialogServiceSub.openAlertGetMessage('E0164', ['指定された表示順が現在の表示順と同一', '更新']);
      return;
    }

    // データ更新条件の設定
    const kymw5300commonVO: KYMW5300commonModel = new KYMW5300commonModel();

    if (showSeq >= toShowSeq) {
      // 上移動の場合
      kymw5300commonVO.moveDiv = '0';
      kymw5300commonVO.moveSeq = showSeq - toShowSeq;
    } else {
      // 下移動の場合
      kymw5300commonVO.moveDiv = '1';
      kymw5300commonVO.moveSeq = toShowSeq - showSeq;
    }

    // 移動の設定
    kymw5300commonVO.orderCode = this.kymw5300Model.orderCode;
    kymw5300commonVO.categoryCode = selectedItem.CategoryCode;
    kymw5300commonVO.categoryLevel = selectedItem.CategoryLevel;
    kymw5300commonVO.showSeq = selectedItem.ShowSeq;
    kymw5300commonVO.categoryCode = selectedItem.CategoryCode;
    kymw5300commonVO.categoryParent = selectedItem.ParentCategoryCode;
    kymw5300commonVO.stockLimitFlg = this.kymw5300Model.stockLimitFlg;
    kymw5300commonVO.updateDate = selectedItem.UpdateDate;

    // サーバー通信
    this.updateCategoryShowSeqInfoService.execute(this.kymw5300Model, kymw5300commonVO, null);
  }

  /**
   * 商品企画マスタがチェックされた時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventchkPlanCategoy_CLICKHandler(): void {
    this.plessEnabledSetting();
    this.clearDetail();
    this.kymw5300Model.clean();
  }

  /**
   * 在庫限定がチェックされた時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5300Component
   */
  public eventchkStockCategory_CLICKHandler(): void {
    this.plessEnabledSetting();
    this.clearDetail();
    this.kymw5300Model.clean();
  }

  /**
   * 終了ボタンクリックイベント
   *
   * @memberof KYMW5300Component
   */
  canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();
    // 編集が行われている場合、メッセージを表示
    if (this.kymw5300Model.isEdited) {
      // 「更新内容が破棄されます。よろしいですか？」
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['カテゴリ情報'],
        (closeDetail) => {                                                      // 「はい」を押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.Yes) {
            this.kymw5300Model.isEdited = false;
            result.next(true);
          } else {
            result.next(false);
          }
        });
        return result;
    } else {
      return true;
    }
  }

  /**
   * 追加取消ボタン押下イベント
   *
   * @param {Event} event
   * @memberof KYMW5300Component
   */
  public eventCancel_CLICKHandler(event: Event): void {
    // クリア処理
    this.eventClear();

    // 追加取消時のカテゴリ詳細情報初期化処理
    this.initDetailForCancel();

    // 移動先表示順クリア
    this.kymw5300Model.toShowSeq = '';

    // 追加取消時の活性制御
    this.enableControlForCancel();

    // フォーカス設定
    this.tre_Category.focus();                                                  // カテゴリ一覧
  }

  /**
   * 項目変更時イベント
   *
   * @memberof KYMW5300Component
   */
  public eventEditHandler(): void {
    this.kymw5300Model.isEdited = true;
  }

  /**
   * イベントクリア
   *
   * @memberof KYMW5300Component
   */
  public eventClear(): void {
    // イベントフラグクリア
    this.eventFlg = '0';

    // 編集フラグクリア
    this.kymw5300Model.isEdited = false;
  }

  /**
   * カテゴリ表示時の活性制御
   *
   * @memberof KYMW5300Component
   */
  public enableControlForDisplay(): void {
    // 活性制御
    this.plessEnabled(this.rdb_PlanCategory, true);                             // 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockCategory, true);                            // 在庫限定ラジオボタン
    this.plessEnabled(this.btn_Display, true);                                  // 表示ボタン
    this.plessEnabled(this.tre_Category, true);                                 // カテゴリ一覧
    this.plessEnabled(this.btn_Upper, false);                                   // ↑ボタン
    this.plessEnabled(this.btn_Lower, false);                                   // ↓ボタン
    this.plessEnabled(this.txti_ToShowSeq, false);                              // 移動表示順
    this.plessEnabled(this.btn_Move, false);                                    // 移動ボタン
    if (this.isFullControl) {                                                   // 「2：フルコントロール可能」の場合
      this.plessEnabled(this.btn_Makeroot, this.kymw5300Model.categoryInfoList.length > 0); // ルート新規作成ボタン
    } else {                                                                    // 「2：フルコントロール可能」以外の場合
      this.plessEnabled(this.btn_Makeroot, false);                              // ルート新規作成ボタン
    }
    this.plessEnabled(this.btn_Addchild, false);                                // 子追加ボタン
    this.plessEnabled(this.btn_Delete, false);                                  // 削除ボタン
    this.plessEnabled(this.btn_Cancel, false);                                  // 追加取消ボタン
    this.plessEnabled(this.btn_Update, false);                                  // 更新ボタン
    this.plessEnabled(this.txti_CategoryName, false);                           // カテゴリ名称
    this.plessEnabled(this.cmb_BorderLineDiv, false);                           // ボーダーライン区分
    this.plessEnabled(this.ckb_ShowDiv, false);                                 // 一時非表示区分
    this.plessEnabled(this.ckb_SellAreaDivB, false);                            // 売場毎表示区分(ブロードバンド)
    this.plessEnabled(this.ckb_SellAreaDivN, false);                            // 売場毎表示区分(ナローバンド)
    this.plessEnabled(this.ckb_SellAreaDivM, false);                            // 売場毎表示区分(携帯)
    this.plessEnabled(this.ckb_SellAreaDivW, false);                            // 売場毎表示区分(Webカタログ)
    this.plessEnabled(this.ckb_SellAreaDivS, false);                            // 売場毎表示区分(スマートフォン)
    this.plessEnabled(this.ckb_SellAreaDivSP, false);                           // 売場毎表示区分(スポット)
    this.plessEnabled(this.ckb_SellAreaDivEC, false);                           // 売場毎表示区分(ECサイト)
    this.plessEnabled(this.ckb_CategoryDiv, false);                             // カテゴリ区分
  }

  /**
   * カテゴリ選択時の活性制御
   *
   * @private
   * @memberof KYMW5300Component
   */
  private enableControlForSelect(): void {
    // 活性制御
    this.plessEnabled(this.rdb_PlanCategory, true);                             // 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockCategory, true);                            // 在庫限定ラジオボタン
    this.plessEnabled(this.cmb_BorderLineDiv, true);
    this.plessEnabled(this.ckb_ShowDiv, true);                                  // 一時非表示区分
    this.plessEnabled(this.ckb_SellAreaDivB, true);                             // 売場毎表示区分(ブロードバンド)
    this.plessEnabled(this.ckb_SellAreaDivN, true);                             // 売場毎表示区分(ナローバンド)
    this.plessEnabled(this.ckb_SellAreaDivM, true);                             // 売場毎表示区分(携帯)
    this.plessEnabled(this.ckb_SellAreaDivW, true);                             // 売場毎表示区分(Webカタログ)
    this.plessEnabled(this.ckb_SellAreaDivS, true);                             // 売場毎表示区分(スマートフォン)
    this.plessEnabled(this.ckb_SellAreaDivSP, true);                            // 売場毎表示区分(スポット)
    this.plessEnabled(this.ckb_SellAreaDivEC, true);                            // 売場毎表示区分(ECサイト)
    this.plessEnabled(this.rdb_PlanCategory, true);                            // 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockCategory, true);                           // 在庫限定ラジオボタン
    this.plessEnabled(this.btn_Display, true);                                  // 表示ボタン
    this.plessEnabled(this.tre_Category, true);                                 // カテゴリ一覧
    this.plessEnabled(this.btn_Upper, true);                                    // ↑ボタン
    this.plessEnabled(this.btn_Lower, true);                                    // ↓ボタン
    this.plessEnabled(this.txti_ToShowSeq, true);                               // 移動先表示順
    this.plessEnabled(this.btn_Move, true);                                     // 移動ボタン
    this.plessEnabled(this.btn_Makeroot, true);                                 // ルート新規作成ボタン
    this.plessEnabled(this.btn_Addchild, true);                                 // 子追加ボタン
    this.plessEnabled(this.btn_Delete, true);                                   // 削除ボタン
    this.plessEnabled(this.btn_Cancel, false);                                  // 追加取消ボタン
    this.plessEnabled(this.btn_Update, true);                                   // 更新ボタン
    this.plessEnabled(this.txti_CategoryName, true);                            // カテゴリ名称
    this.categoryDivEnabledSetting();

    // 選択カテゴリ、親カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;	                  // 選択カテゴリ

    let parentItem: any = null;
    let parentLen = Number(0);
    if (this.tre_Category.getNode(selectedItem).parentNode) {

      parentItem = this.tre_Category.getNode(selectedItem).parentNode.dataItem; // 親カテゴリ
      // 親カテゴリの子カテゴリ数を取得
      parentLen = parentItem.Category.length;
    }

    // 選択カテゴリのリストインデックスを取得
    const selectIndx: number = selectedItem.ShowSeq - 1;

    // 選択カテゴリのリストインデックスのチェック
    if (selectIndx === 0) {                                                     // 先頭カテゴリの場合
      // 活性制御
      this.plessEnabled(this.btn_Upper, false);                                 // ↑ボタン
    } else {                                                                    // 先頭カテゴリでない場合
      // 活性制御
      this.plessEnabled(this.btn_Upper, true);                                  // ↑ボタン
    }

    // 選択カテゴリのリストインデックス、親カテゴリの子カテゴリ数のチェック
    if (selectIndx === (parentLen - 1)) {                                       // 末尾カテゴリの場合
      // 活性制御
      this.plessEnabled(this.btn_Lower, false);                                 // ↓ボタン
    } else {                                                                    // 末尾カテゴリでない場合
      // 活性制御
      this.plessEnabled(this.btn_Lower, true);                                  // ↓ボタン
    }

    if (this.isFullControl) {                                                   // 「2：フルコントロール可能」の場合
      this.plessEnabled(this.btn_Update, true);                                 // 更新ボタン
      this.plessEnabled(this.btn_Delete, true);                                 // 削除ボタン
      this.plessEnabled(this.btn_Makeroot, true);                               // 新規ルートを作成ボタン
      this.plessEnabled(this.btn_Addchild, true);                               // 子を追加ボタン
    } else {                                                                    // 「2：フルコントロール可能」以外の場合
      this.plessEnabled(this.btn_Update, false);                                // 更新ボタン
      this.plessEnabled(this.btn_Delete, false);                                // 削除ボタン
      this.plessEnabled(this.btn_Makeroot, false);                              // 新規ルートを作成ボタン
      this.plessEnabled(this.btn_Addchild, false);                              // 子を追加ボタン
    }
  }

  /**
   * カテゴリ追加時の活性制御（親子共通）
   *
   * @memberof KYMW5300Component
   */
  public enableControlForAddCategory(): void {
    this.plessEnabled(this.rdb_PlanCategory, false);                             // 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockCategory, false);                            // 在庫限定ラジオボタン
    this.plessEnabled(this.cmb_BorderLineDiv, true);
    this.plessEnabled(this.ckb_ShowDiv, true);
    this.plessEnabled(this.ckb_SellAreaDivB, true);
    this.plessEnabled(this.ckb_SellAreaDivN, true);
    this.plessEnabled(this.ckb_SellAreaDivM, true);
    this.plessEnabled(this.ckb_SellAreaDivW, true);
    this.plessEnabled(this.ckb_SellAreaDivS, true);
    this.plessEnabled(this.ckb_SellAreaDivSP, true);
    this.plessEnabled(this.ckb_SellAreaDivEC, true);

    this.plessEnabled(this.txti_OrderCode, false);
    this.plessEnabled(this.btn_Display, false);
    this.plessEnabled(this.tre_Category, false);
    this.plessEnabled(this.btn_Upper, false);
    this.plessEnabled(this.btn_Lower, false);
    this.plessEnabled(this.txti_ToShowSeq, false);
    this.plessEnabled(this.btn_Move, false);
    this.plessEnabled(this.btn_Makeroot, false);
    this.plessEnabled(this.btn_Addchild, false);
    this.plessEnabled(this.btn_Delete, false);
    this.plessEnabled(this.btn_Cancel, true);
    this.plessEnabled(this.btn_Update, true);
    this.plessEnabled(this.txti_CategoryName, true);
    this.categoryDivEnabledSetting();
  }

  /**
   * 追加取消時の活性制御
   *
   * @private
   * @memberof KYMW5300Component
   */
  private enableControlForCancel(): void {
    this.plessEnabled(this.txti_OrderCode, true);
    // カテゴリ選択チェック
    if (PlessViewUtilsSub.isEmpty(this.tre_Category.selectedItem)) {            // 未選択の場合
      // カテゴリ表示時の活性制御
      this.enableControlForDisplay();
    } else {                                                                    // 選択済の場合
      // カテゴリ選択時の活性制御
      this.enableControlForSelect();
    }
  }

  /**
   * カテゴリ選択時のカテゴリ詳細情報初期化処理
   *
   * @private
   * @returns {void}
   * @memberof KYMW5300Component
   */
  private initDetailForSelect(): void {
    // 選択カテゴリを取得
    const selectedItem: any = this.tre_Category.selectedItem;                   // 選択カテゴリ
    // アイテムが取得できない場合は表示項目をクリアして処理を抜ける
    if (!selectedItem) {
      this.clearDetail();
      return;
    }

    let parentItem: any;
    if (this.tre_Category.getNode(selectedItem).parentNode) {
      parentItem = this.tre_Category.getNode(selectedItem).parentNode.dataItem; // 親カテゴリ
    }

    // カテゴリ詳細の初期化処理
    this.kymw5300Model.categoryCode = selectedItem.CategoryCode;                // カテゴリコード

    let category_nm: string = selectedItem.CategoryName;
    let iPos: number = category_nm.indexOf(':');

    // 「:」より前の文字列(表示順)をカット
    category_nm = category_nm.slice(iPos + 1);                                  // カテゴリ名称

    this.kymw5300Model.categoryName = category_nm;

    // 親カテゴリのチェック
    if (!parentItem) {                                                          // 親カテゴリなしの場合
      // カテゴリ詳細の初期化処理
      this.kymw5300Model.categoryParentName = '';                               // 親カテゴリ名称
    } else {                                                                    // 親カテゴリありの場合
      // カテゴリ詳細の初期化処理
      category_nm = parentItem.CategoryName;
      iPos = category_nm.indexOf(':');

      // 「:」より前の文字列(表示順)をカット
      category_nm = category_nm.slice(iPos + 1);
      this.kymw5300Model.categoryParentName = category_nm;                      // 親カテゴリ名称
    }

    this.kymw5300Model.borderLineDiv = selectedItem.BorderLineDiv;
    this.kymw5300Model.showDiv = selectedItem.ShowDiv === '1';
    this.kymw5300Model.sellAreaDivB = selectedItem.SellAreaDivB === '1';
    this.kymw5300Model.sellAreaDivN = selectedItem.SellAreaDivN === '1';
    this.kymw5300Model.sellAreaDivM = selectedItem.SellAreaDivM === '1';
    this.kymw5300Model.sellAreaDivW = selectedItem.SellAreaDivW === '1';
    this.kymw5300Model.sellAreaDivS = selectedItem.SellAreaDivS === '1';
    this.kymw5300Model.sellAreaDivSP = selectedItem.SellAreaDivSP === '1';
    this.kymw5300Model.sellAreaDivEC = selectedItem.SellAreaDivEC === '1';
    this.kymw5300Model.categoryDiv = selectedItem.CategoryDiv === '0';
  }

  /**
   * 追加取消時のカテゴリ詳細情報初期化処理
   *
   * @private
   * @memberof KYMW5300Component
   */
  private initDetailForCancel(): void {
    // カテゴリ選択時のカテゴリ詳細情報初期化処理
    this.initDetailForSelect();
  }

  /**
   * カテゴリ詳細情報クリア処理
   *
   * @memberof KYMW5300Component
   */
  public clearDetail(): void {
    // カテゴリ詳細情報初期化処理
    this.kymw5300Model.categoryCode = '';                                       // カテゴリコード
    this.kymw5300Model.categoryName = '';                                       // カテゴリ名称
    this.kymw5300Model.categoryParentName = '';                                 // 親カテゴリ名称
    this.kymw5300Model.borderLineDiv = '';                                      // ボーダーライン区分
    this.kymw5300Model.showDiv = false;                                         // 一時非表示区分
    this.kymw5300Model.sellAreaDivB = false;                                    // 売場毎表示区分(ブロードバンド)
    this.kymw5300Model.sellAreaDivN = false;                                    // 売場毎表示区分(ナローバンド)
    this.kymw5300Model.sellAreaDivM = false;                                    // 売場毎表示区分(携帯)
    this.kymw5300Model.sellAreaDivW = false;                                    // 売場毎表示区分(Webカタログ)
    this.kymw5300Model.sellAreaDivS = false;                                    // 売場毎表示区分(スマートフォン)
    this.kymw5300Model.sellAreaDivSP = false;                                   // 売場毎表示区分(スポット)
    this.kymw5300Model.sellAreaDivEC = false;                                   // 売場毎表示区分(ECサイト)
    this.kymw5300Model.categoryDiv = false;                                     // カテゴリ区分   
  }

  /**
   * 受注コード比較
   * テキストインプットフィールドに表示されている受注コードとカテゴリ一覧表示中の受注コードが
   * 一致しているか否かを判定し、判定結果を返却する。
   *
   * @returns {boolean}
   * @memberof KYMW5300Component
   */
  public checkOrderCode(): boolean {
    // テキストインプットフィールドに表示されている受注コードとカテゴリ一覧表示中の受注コードの比較
    if (this.txti_OrderCode.text === this.kymw5300Model.orderCode) {            // 同一受注コードの場合
      // 判定結果(一致)を返却
      return true;
    } else {                                                                    // 異なる場合
      // 判定結果(不一致)を返却
      return false;
    }
  }

  /**
   * ツリーの再ロード
   *
   * @memberof KYMW5300Component
   */
  public updateTreeView() {
    // ツリーのロード
    this.tre_Category.loadTree();
    // 初期表示は展開しない
    this.tre_Category.expandOnLoad = false;
  }

  /**
   * オーダーコード変更時処理
   *
   * @memberof KYMW5300Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    this.kymw5300Model.catalogId = this.txti_OrderCode.selectedCatalogID;
  }

  /**
   * Creates an instance of KYMW5300Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {GetCategoryInfoService} getCategoryInfoService
   * @param {UpdateCategoryShowSeqInfoService} updateCategoryShowSeqInfoService
   * @param {UpdateCategoryInfoService} updateCategoryInfoService
   * @param {RegistCategoryInfoService} registCategoryInfoService
   * @param {DeleteCategoryInfoService} deleteCategoryInfoService
   * @param {ChangeDetectorRef} changeDetectorRef
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @memberof KYMW5300Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    public getCategoryInfoService: GetCategoryInfoService,
    private updateCategoryShowSeqInfoService: UpdateCategoryShowSeqInfoService,
    private updateCategoryInfoService: UpdateCategoryInfoService,
    private registCategoryInfoService: RegistCategoryInfoService,
    private deleteCategoryInfoService: DeleteCategoryInfoService,
    public changeDetectorRef: ChangeDetectorRef,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * ツリー内のデザインを整えるクラス CategoryTreeRendererから移植
   *
   * @param {TreeView} treeView
   * @param {FormatNodeEventArgs} e
   * @memberof KYMW5300Component
   */
  formatItem(treeView: TreeView, e: FormatNodeEventArgs) {
    // タイムセールカテゴリは赤字で表示する
    if (e.dataItem.TimeSaleFlg === '1') {
      e.element.innerHTML =
        `<span class="time_sale_category">${e.dataItem.CategoryName}</span>`;
    }
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW5300Component
   */
  plessEnabledSetting() {
    this.plessEnabled(this.rdb_PlanCategory, true);                            // 商品企画マスタラジオボタン
    this.plessEnabled(this.rdb_StockCategory, true);                           // 在庫限定ラジオボタン
    this.plessEnabled(this.txti_OrderCode, true);                               // 受注コード
    this.plessEnabled(this.btn_Display, true);                                  // 表示ボタン
    this.plessEnabled(this.tre_Category, false);                                // カテゴリ一覧
    this.plessEnabled(this.btn_Makeroot, false);                                // ルート新規作成ボタン
    this.plessEnabled(this.btn_Addchild, false);                                // 子追加ボタン
    this.plessEnabled(this.btn_Delete, false);                                  // 削除ボタン
    this.plessEnabled(this.btn_Upper, false);                                   // 上矢印ボタン
    this.plessEnabled(this.btn_Lower, false);                                   // 下矢印ボタン
    this.plessEnabled(this.txti_ToShowSeq, false);                              // 移動先表示順
    this.plessEnabled(this.btn_Move, false);                                    // 移動ボタン
    this.plessEnabled(this.btn_Cancel, false);                                  // 追加取消ボタン
    this.plessEnabled(this.btn_Update, false);                                  // 更新ボタン
    this.plessEnabled(this.txti_CategoryName, false);                           // カテゴリ名称
    this.plessEnabled(this.cmb_BorderLineDiv, false);                           // ボーダーライン区分
    this.plessEnabled(this.ckb_ShowDiv, false);                                 // 一時非表示区分
    this.plessEnabled(this.ckb_SellAreaDivB, false);                            // 売場毎表示区分(ブロードバンド)
    this.plessEnabled(this.ckb_SellAreaDivN, false);                            // 売場毎表示区分(ナローバンド)
    this.plessEnabled(this.ckb_SellAreaDivM, false);                            // 売場毎表示区分(携帯)
    this.plessEnabled(this.ckb_SellAreaDivW, false);                            // 売場毎表示区分(Webカタログ)
    this.plessEnabled(this.ckb_SellAreaDivS, false);                            // 売場毎表示区分(スマートフォン)
    this.plessEnabled(this.ckb_SellAreaDivSP, false);                           // 売場毎表示区分(スポット)
    this.plessEnabled(this.ckb_SellAreaDivEC, false);                           // 売場毎表示区分(ECサイト)
    this.plessEnabled(this.ckb_CategoryDiv, false);                             // カテゴリ区分

    this.rdb_PlanCategory.setFocus();
  }

  /**
   * カテゴリ区分の活性・非活性制御処理
   *
   * @memberof KYMW5300Component
   */
  categoryDivEnabledSetting() {
    if (this.isFullControl) {                                                             // 「2：フルコントロール可能」の場合
      this.plessEnabled(this.ckb_CategoryDiv, this.kymw5300Model.stockLimitFlg === '0');  //  在庫限定フラグ
    } else {                                                                              // 「2：フルコントロール可能」以外の場合
      this.plessEnabled(this.ckb_CategoryDiv, false);
    }
  }
}
